import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: 'app-confirm-delete-new',
  template: `
    <div class="modal-header py-2 bg-light">
      <h5 class="modal-title">{{ title || (titlePage | transloco) }}</h5>
      <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"
              (click)="_modalService.dismiss()"></button>
    </div>
    <div class="modal-body">
      @if (!totalPages || !isCheck) {
        <p class="mb-0" [innerHTML]="content || ('common.messages.confirmDelete' | transloco)"></p>
      }
      @if (totalPages && isCheck) {
        <div class="mt-2">
          <app-progress-bar [totalPages]="totalPages" [currentPage]="currentPage"></app-progress-bar>
        </div>
      }
      @if (isCompleteError.length) {
        <div class="alert alert-info col-12 mt-2">
          <div class="customScroll">
            @for (ms of isCompleteError; track ms) {
              <div>
                <p class="m-0" [innerHTML]="ms"></p>
              </div>
            }
          </div>
        </div>
      }
      @if (alert) {
        <div class="alert alert-warning mt-2 mb-0">
          {{ 'feature.chatbot.marketingNote' | transloco }} {{ alert | transloco}}
        </div>
      }
    </div>
    <div class="modal-footer py-1 bg-light">
      <button type="button" class="btn btn-light" (click)="_modalService.dismiss()">{{ 'common.cancel' | transloco }}</button>
      <button type="button" class="btn btn-danger ms-2" (click)="_modalService.close(true)">
        <i class="ph ph-trash me-1"></i>{{ 'common.delete' | transloco }}
      </button>
    </div>
 `,
  styles: [`
   .customScroll {
     height: 100px;
     overflow-y: auto;
     -ms-overflow-style: -ms-autohiding-scrollbar;
     scrollbar-width: thin;
     scrollbar-color: var(--gray-600) transparent;
   }
 `],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmDeleteNewComponent {
  @Input() title = '';
  @Input() content = '';
  @Input() titlePage = 'common.deleteSelectedLines';
  @Input() totalPages: number = 0;
  @Input() isCheck: boolean = false;
  @Input() currentPage: number = 0;
  @Input() isCompleteError: string[] = [];
  @Input() alert = '';
  @Output() progressUpdate = new EventEmitter<number>();

  constructor(
    public _modalService: NgbActiveModal
  ) {
  }

  onClose() {
    this._modalService.dismiss(true);
  }

  updateProgress(progress: number) {
    this.currentPage = progress;
    this.progressUpdate.emit(this.currentPage);
  }
}
